import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const CustomersTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  {
    title: 'Name',
    align: 'start',
    key: 'displayName',
    placeholder: 'Customer name',
  },
  {
    title: 'Revenue Stream',
    align: 'start',
    key: 'revenueStreamGUID',
    placeholder: 'Revenue stream',
  },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
